const BASE_ACTION = "CHARTS/";
export const SET_CHART_LOADING = `${BASE_ACTION}SET_CHART_LOADING`;
export const SET_CHART_TAG_DATA_LOADING = `${BASE_ACTION}SET_CHART_TAG_DATA_LOADING`;
export const CHART_DATA_SUCCESS = `${BASE_ACTION}CHART_DATA_SUCCESS`;
export const SET_CHART_TAGS = `${BASE_ACTION}SET_CHART_TAGS`;
export const RESET_CHART_DATA = `${BASE_ACTION}RESET_CHART_DATA`;
export const UPDATE_CHART_FORMAT = `${BASE_ACTION}UPDATE_CHART_FORMAT`;
export const UPDATE_CHART_DURATION = `${BASE_ACTION}UPDATE_CHART_DURATION`;
export const SET_DURATION_RANGES = `${BASE_ACTION}CHART_DURATION_RANGES`;
export const RESET_CHART_TAGS_DATA = `${BASE_ACTION}RESET_CHART_TAGS_DATA`;
export const SET_PLOT_DATA = `${BASE_ACTION}SET_PLOT_DATA`;
export const UPDATE_PLOT_DATA = `${BASE_ACTION}UPDATE_PLOT_DATA`;
export const ADD_TAG_SUCCESS = `${BASE_ACTION}ADD_TAG_SUCCESS`;
export const UPDATE_TAGS_WITHOUT_DATA = `${BASE_ACTION}UPDATE_TAGS_WITHOUT_DATA`;
export const DELETE_TAG_SUCCESS = `${BASE_ACTION}DELETE_TAG_SUCCESS`;
export const SET_CURRENT_EDITVIEW = `${BASE_ACTION}SET_CURRENT_EDITVIEW`;
export const UPDATE_EDITED_TAGS = `${BASE_ACTION}UPDATE_EDITED_TAGS`;
export const SET_ALARMS_HISTORY = `${BASE_ACTION}SET_ALARMS_HISTORY`;
export const UPDATE_ALARMS = `${BASE_ACTION}UPDATE_ALARMS`;
export const UPDATE_NORMALIZE_FILTERS = `${BASE_ACTION}UPDATE_NORMALIZE_FILTERS`;
export const RESET_TAGS_DATA = `${BASE_ACTION}RESET_TAGS_DATA`;
export const ON_CHART_PLOT_ZOOM = `${BASE_ACTION}ON_CHART_PLOT_ZOOM`;
export const TAGS_LIMITS = `${BASE_ACTION}TAGS_LIMITS`;

const CHART_ACTIONS = {
  SET_CHART_LOADING,
  SET_CHART_TAG_DATA_LOADING,
  CHART_DATA_SUCCESS,
  SET_CHART_TAGS,
  RESET_CHART_DATA,
  RESET_CHART_TAGS_DATA,
  RESET_TAGS_DATA,
  SET_PLOT_DATA,
  UPDATE_CHART_FORMAT,
  UPDATE_PLOT_DATA,
  UPDATE_CHART_DURATION,
  SET_DURATION_RANGES,
  ADD_TAG_SUCCESS,
  DELETE_TAG_SUCCESS,
  UPDATE_TAGS_WITHOUT_DATA,
  SET_CURRENT_EDITVIEW,
  UPDATE_EDITED_TAGS,
  SET_ALARMS_HISTORY,
  UPDATE_ALARMS,
  UPDATE_NORMALIZE_FILTERS,
  ON_CHART_PLOT_ZOOM,
  TAGS_LIMITS
};

export default CHART_ACTIONS;
